export const urls = {
    updateReview: id => `/api/reviews/${ id }`,
    reviews: (buyerId, sellerId, adId) => `/api/users/${ buyerId }/reviews/${ sellerId }/ads/${ adId }`
};

export const initialState = {
    data: {},
    metadata: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_REVIEWS':
            return {
                data: state.data ? state.data : {},
                metadata: state.metadata ? state.metadata : {},
                isFetching: true,
                isError: false
            };
        case 'RECEIVE_REVIEWS':
        case 'RESPONSE_PATCH_REVIEWS':
            return {
                data: action.data.data,
                metadata: action.data.metadata,
                isFetching: false,
                isError: false
            };
        case 'ERROR_REVIEWS':
        case 'ERROR_PATCH_REVIEWS':
            return {
                data: {},
                metadata: {},
                isFetching: false,
                isError: true
            };
        default:
            return state;
    }
};
